import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import { initClient } from '../../api';
import { OeeApiClient, OeeOverShiftBreakdown } from '../backend/backendapi';
import { VMEvent, VMEventInput, VMUser } from './event.dto';

Vue.use(Toasted);

@Component
export default class EventComponent extends Vue {
    vm: VMEventInput = new VMEventInput();

    selectedIndex = -1;

    pageSize = 2;

    eventsPage: VMEvent[] = [];
    currentPage = 1;
    totalPages = 0;
    isOperatorSelected: boolean = false;
    operators: VMUser[] = [];
    currentOperator: VMUser | any;
    overShifts: OeeOverShiftBreakdown[] = [];

    private oeeApiClient = initClient(OeeApiClient);

    mounted() {
        fetch('api/event')
            .then(response => response.json() as Promise<VMEventInput>)
            .then(data => {
                this.vm = data;
                console.log(this.vm);
            });

        fetch('api/operators').then(response => response.json() as Promise<VMUser[]>)
            .then(data => {
                this.operators = data;
            });
        this.oeeApiClient.getOpenOvershifts().then(d => {
            console.log("overshifts", d.result);
            this.overShifts.splice(0);
            this.overShifts.push(...d.result!);
        });
    }

    login(operator: VMUser) {
        this.currentOperator = operator;
        this.isOperatorSelected = true;
    }

    logout() {
        this.isOperatorSelected = false;
        this.currentOperator = null;
    }

    selectLabel(index: number) {
        this.selectedIndex = index;
        this.totalPages = Math.ceil(this.events.length / this.pageSize);
        this.eventsPage = this.events.slice(0, this.pageSize);
        this.currentPage = 1;
    }

    getPage(pageIndex: number) {
        const currentIndex = (pageIndex - 1) * this.pageSize;
        this.eventsPage = this.events.slice(currentIndex, currentIndex + this.pageSize);
        this.currentPage = pageIndex;
    }

    postEvent(event: VMEvent, buttonNo: number) {
        const currentLabel = this.vm.labels[this.selectedIndex];
        event.labelId = currentLabel.id;
        event.labelName = currentLabel.name;
        event.userId = this.currentOperator.id;
        if (buttonNo > 0) {
            event.buttonNo = buttonNo;
        }

        console.log('payload before sending', event);
        let myToast = this.$toasted.show('Event ' + event.name);
        myToast.goAway(1000);

        fetch('api/event',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(event)
            })
            .then(response => response.json())
            .then(data => {
                console.log('returned data', data);
            });
    }

    private async closeOverShift(overShift: OeeOverShiftBreakdown): Promise<void> {
        await this.oeeApiClient.closeOpenOvershifts(overShift.id!);
        let i = this.overShifts.findIndex(e => e.id === overShift.id);
        if (i !== undefined) {
            this.overShifts.splice(i, 1);
        }
        this.$toasted.show(this.$t('txtClosed').toString()).goAway(1000);
    }

    get events(): VMEvent[] {
        if (this.selectedIndex < 0) { return []; }

        return this.vm.labels[this.selectedIndex].events;
    }
}